import styled, { keyframes } from "styled-components";
 
const spin = keyframes`
  from {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
`;
 
export const LoaderContainer = styled.div`
  position: fixed;
  top: 0px;
  width: 100vw;
  height: 100vh;
  left: 0;
  background: #000000cc;
  display: grid;
  place-content: center;
  gap: 10px;
  z-index: 9999;
  & img {
    animation: ${spin} 2s linear infinite;
  }
  & span {
    color: #ffffff;
    font-family: "Lato-Bold";
  }
`;
 